<template>
  <article class="popup popup-padding">
    <header class="popup-top">
      <h2 class="title">{{$t('popups.addUser.title')}}</h2>
      <div class="popup-top_btns">
        <question-btn :text="$t('prompts.addUser')"></question-btn>
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <div v-if="success" class="success-cont">
      <h3 class="title" v-if="error">{{$t('errors.inviteError')}}</h3>
      <h3 class="title" v-else-if="errorDouble">{{$t('errors.doubleError')}}</h3>
      <h3 class="title" v-else>{{$t('popups.addUser.success')}}</h3>
      <button type="button"
              @click="closeAll"
              class="btn btn-blue">{{$t('btns.ok')}}</button>
    </div>
    <form v-else
          class="add-user-form"
          @submit.prevent="addUser">
      <label class="input-cont input-cont_small"
             :class="{'error': $v.mail.$error || mailError}">
        <p class="label">{{$t('popups.addUser.mailLb')}}</p>
        <input type="email"
               v-model="mail"
               @blur="$v.mail.$touch()"
               @focus="$v.mail.$reset();hideMailError()"
               placeholder="mail@mail.com">
        <errors v-show="$v.mail.$error" type="mail"></errors>
        <errors :type="'mailFalse'" v-show="mailError"></errors>
      </label>
      <div class="select-cont select-cont_multiple" v-if="!inviteRoleId">
        <p class="label">{{$t('popups.addUser.setRole')}}</p>
        <v-select multiple
                  :searchable="true"
                  :clearable="false"
                  label="name"
                  v-model="roles"
                  :options="ownedRoles"></v-select>
      </div>
      <div class="btns-bottom">
        <button type="button"
                :disabled="loading"
                @click="closeAll"
                class="btn btn-transparent_blue">{{$t('btns.cancel')}}</button>
        <button type="submit"
                :disabled="$v.$anyError || disableBtn || loading"
                :class="{'loading': loading}"

                class="btn btn-blue">{{$t('btns.create')}}</button>
      </div>
    </form>
  </article>
</template>

<script>
  import closeBtn from '../../closeBtn'
  import questionBtn from '../../questionBtn'
  import {popups} from "../../../../mixins/popups";
  import {required, email} from 'vuelidate/lib/validators'
  import errors from '../../../Forms/errors'
  import {mapState, mapMutations, mapActions} from 'vuex'
  import {tokenAndRoute} from "../../../../mixins/utils/tokenAndRoute";

  export default {
    name: 'addUserPopup',
    mixins: [popups, tokenAndRoute],
    components: {
      closeBtn,
      questionBtn,
      errors
    },
    data() {
      return {
        mail: '',
        roles: [],
        loading: false,
        success: false,
        error: false,
        errorDouble: false,
      }
    },
    computed: {
      ...mapState({
        ownedRoles: state => state.roles.ownedRoles,
        mailError: state => state.roles.doubleMailError,
        userData: state => state.auth.user,
        inviteRoleId: state => state.popups.addUser.roleId
      }),
      disableBtn() {
        return (!this.mail);
      },
    },
    methods: {
      ...mapMutations({
        setMailError: 'roles/SET_DOUBLE_MAIL',
        setRoleId: 'popups/addUser/SET_ROLE_ID'
      }),
      ...mapActions({
        getOwnedRoles: 'roles/getOwnedRoles',
        assignRoleToUser: 'roles/assignRoleToUser',
        inviteUser: 'roles/inviteUser',
        getUsers: 'roles/getUsers',
        getInvitedUsers: 'roles/getInvitedUsers'
      }),
      hideMailError() {
        this.setMailError(false)
      },
      async addUser() {
        this.loading = true;
        let ids = this.roles.map(item => {
          return item.id
        }).join(',');
        if (this.inviteRoleId) {
          ids = String(this.inviteRoleId)
        };
        //если прикрепляем к ролям
        if (ids) {
          await this.assignRoleToUser({
            token: this.token,
            email: this.mail,
            ids,
          }).catch(e => {
            this.loading = false;
            if (e.message == 'error') {
              this.loading = false;
              this.success = true;
              this.error = true
            }
          });
        } else {
          //создание инвайта для незареганого
          await this.inviteUser({
            token: this.token,
            email: this.mail,
            ids: '0'
          }).catch(e => {

            this.loading = false;
            if (e.message == 'error') {
              this.loading = false;
              this.success = true;
              this.error = true
            };

            if (e.message == 'registered') {
              this.loading = false;
              this.success = true;
              this.errorDouble = true;
            }
          });
        };
        this.getUsers(this.token);
        this.getInvitedUsers(this.token);
        this.loading = false;
        this.success = true;
      }
    },
    validations: {
      mail: {
        email,
        required
      },
    },
    mounted() {
      this.getOwnedRoles({token: this.token, id: ''})
    },
    destroyed() {
      this.setRoleId('');
      this.error = false;
      this.loading = false;
      this.success = false;
      this.errorDouble = false;
    }
  }
</script>

<style lang="scss" scoped>
  .input-cont {
    margin-bottom: 20px;
  }

  .title {
    line-height: 120%;
  }

  .check-cont {
    margin-top: 20px;
  }

  .success-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    padding: 0 30px;

    button {
      margin-top: 20px;
    }
  }
</style>
